import React from "react";
import { Experience, Package } from "types";
import { NoResults } from "../Common/NoResults";
import { PackageTile } from "./PackageTile";

export const PackageList = ({
    packages,
    experiences,
    partnerPackages = false,
}: {
    packages: Package[];
    experiences: Experience[];
    partnerPackages?: boolean;
}) => {
    return (
        <div className="px-0 py-10">
            <div className="text-lg font-bold">{partnerPackages ? "Partner" : ""} Packages</div>
            {packages.length === 0 ? (
                <NoResults>No results found</NoResults>
            ) : (
                <div className="mt-10 grid grid-cols-3 gap-y-5 gap-x-2" data-testid="experience-list">
                    {packages.map((pkg) => (
                        <PackageTile key={pkg.id} pkg={pkg} experiences={experiences} />
                    ))}
                </div>
            )}
        </div>
    );
};
